import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { adminApi } from '../../services/adminApi';
import type { StorePreview } from '../../types/admin';
import { AdminPageHeader } from './adminShared';
import './AdminLayout.css';

const AdminStoreNew: React.FC = () => {
  const navigate = useNavigate();
  const [storeId, setStoreId] = useState('');
  const [preview, setPreview] = useState<StorePreview | null>(null);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  const handlePreview = async () => {
    const id = storeId.trim();
    if (!id) {
      setError('Ingresá un store_id');
      return;
    }

    setLoading(true);
    setError('');
    setPreview(null);

    try {
      const data = await adminApi.previewStore(id);
      setPreview(data);
      if (data.already_in_supabase) {
        setError('Esta tienda ya existe en Supabase.');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error en preview Boris');
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async () => {
    const id = storeId.trim();
    if (!id || !preview || preview.already_in_supabase) return;

    if (!window.confirm(`¿Crear la tienda "${preview.store_name}" (${id})?`)) return;

    setCreating(true);
    setError('');
    try {
      await adminApi.createStore(id);
      navigate(`/admin/stores/${id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error creando tienda');
    } finally {
      setCreating(false);
    }
  };

  return (
    <>
      <AdminPageHeader title="Nueva tienda" />

      {error && <div className="admin-alert admin-alert-error">{error}</div>}

      <div className="admin-card">
        <div className="admin-form">
          <div className="admin-form-row">
            <label htmlFor="storeId">Store ID (Boris)</label>
            <input
              id="storeId"
              className="admin-input"
              value={storeId}
              onChange={(e) => {
                setStoreId(e.target.value);
                setPreview(null);
              }}
              placeholder="ej. 219431"
            />
          </div>

          <div className="admin-form-actions">
            <button
              type="button"
              className="admin-btn admin-btn-secondary"
              onClick={handlePreview}
              disabled={loading}
            >
              {loading ? 'Consultando…' : 'Preview Boris'}
            </button>
            <Link to="/admin/stores" className="admin-btn admin-btn-secondary" style={{ textDecoration: 'none' }}>
              Cancelar
            </Link>
          </div>
        </div>

        {preview && (
          <div style={{ marginTop: 24, paddingTop: 24, borderTop: '1px solid var(--color-border)' }}>
            <h3 style={{ margin: '0 0 12px' }}>Preview</h3>
            <div className="admin-detail-grid">
              <div className="admin-detail-item">
                <label>Nombre</label>
                <span>{preview.store_name}</span>
              </div>
              <div className="admin-detail-item">
                <label>Store ID</label>
                <span>{preview.store_id}</span>
              </div>
              <div className="admin-detail-item">
                <label>País</label>
                <span>{preview.country || '—'}</span>
              </div>
              <div className="admin-detail-item">
                <label>API Key</label>
                <span>{preview.has_api_key ? preview.tiendanube_api_key_masked : 'No configurada'}</span>
              </div>
            </div>

            {!preview.already_in_supabase && preview.has_api_key && (
              <button
                type="button"
                className="admin-btn admin-btn-primary"
                onClick={handleCreate}
                disabled={creating}
              >
                {creating ? 'Creando…' : 'Confirmar creación'}
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default AdminStoreNew;
